import React, { Component } from 'react';
import {
  Button,
  Dialog,
  Grid,
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  // Link,
} from '@material-ui/core';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withCookies } from 'react-cookie';
import _ from 'lodash';
// import Modal from 'react-responsive-modal';

import {
  submitLoginAction,
  submitOrgsLoginAction,
  resetRegistrationAction,
  handleLoginModalAction,
  submitLoginAsSeedCompAction,
  submitFarmconnectLoginAction,
} from '../../Actions/appAction';
import {
  isMobile,
  isPassword,
  isEmail,
} from '../../Functions/commonValidation';

import LanguageContext from '../common/languageContext';
import SocialLogin from '../siFoloModal/socialLogin';

class LoginModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
      mobile: '',
      email: '',
      password: '',
      mobileError: false,
      passwordError: false,
      emailError: false,
      loginViaEmail: false,
      accountType: '9b5b09a0-e70f-9020-fc9a-edf5c54d0a7a',
      accountTypeName: 'Insurance',
      accountValue: '9b5b09a0-e70f-9020-fc9a-edf5c54d0a7a//Insurance',
    };
    // this.handleAccountType = this.handleAccountType.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      cookies, userData, history, isLogin,
    } = this.props;
    if (isLogin !== prevProps.isLogin) {
      cookies.set('userData', userData, { path: '/' });
      cookies.set('loggedInTimeStamp', Date.now());
      const { data } = userData;
      const { userRoleData } = data;
      if (!_.isEmpty(userRoleData)) {
        history.push({
          pathname: '/setup/step3',
          search: '',
          hash: '',
          state: { from: 'login' },
        });
      }

      /* const { roles } = data;
      if (roles && roles.length > 0) {
        if (roles[0].roleName === 'farmer') {
          history.push({
            pathname: '/myaccount',
            search: '',
            hash: '',
            state: { from: 'login' },
          });
        } else {
          history.push({
            pathname: '/setup/step3',
            //  pathname: '/setup/step1',
            search: '',
            hash: '',
            state: { from: 'login' },
          });
        }
      } else {
        history.push({
          pathname: '/tagging',
          search: '',
          hash: '',
          state: { from: 'login' },
        });
      } */
    }
  }

  _handleClose = () => {
    const { resetRegistration, handleLoginModal } = this.props;
    this.setState({
      open: false,
      mobile: '',
      email: '',
      password: '',
      mobileError: false,
      passwordError: false,
      emailError: false,
      loginViaEmail: false,
    });
    resetRegistration();
    handleLoginModal(false);
  };

  handleOpen = (ev) => {
    if (ev.key !== 'Tab') {
      this.setState({
        open: true,
      });
    }
  };

  _handleLogin = (type, ev) => {
    if (type === 'mobile') {
      if (ev.target.value.length <= 10) {
        this.setState({
          mobile: ev.target.value,
          mobileError: false,
        });
      }
    } else if (type === 'password') {
      this.setState({
        password: ev.target.value,
        passwordError: false,
      });
    } else if (type === 'email') {
      this.setState({
        email: ev.target.value,
        emailError: false,
      });
    }
  };

  _handleAccountType = (e) => {
    // debugger;
    this.setState({
      accountType: e.target.value.split('//')[0],
      accountTypeName: e.target.value.split('//')[1],
      accountValue: e.target.value,
    });
  };

  _submitLogin = () => {
    const {
      submitLogin,
      submitOrgsLogin,
      /* submitLoginAsSeedComp, */ submitFarmconnectLogin,
    } = this.props;
    const {
      mobile,
      email,
      password,
      loginViaEmail,
      accountTypeName,
    } = this.state;
    const passwordErrorCheck = !isPassword(password);
    if (loginViaEmail) {
      const emailErrorCheck = !isEmail(email);
      this.setState({
        emailError: emailErrorCheck,
      });
      if (accountTypeName === 'Farmer') {
        if (!emailErrorCheck && !passwordErrorCheck) submitLogin(mobile, password, 'email');
      } else if (!emailErrorCheck && !passwordErrorCheck) submitOrgsLogin(mobile, password, 'email');
    } else {
      const mobileErrorCheck = !isMobile(mobile);
      this.setState({
        mobileError: mobileErrorCheck,
      });
      if (!mobileErrorCheck && !passwordErrorCheck) {
        submitFarmconnectLogin(mobile, password, 'web');
      }
      // if (accountTypeName === 'Farmer') {
      //   if (!mobileErrorCheck && !passwordErrorCheck) submitLogin(mobile, password, 'mobile');
      // }
      // if (accountTypeName === 'Seed company') {
      //   if (!mobileErrorCheck && !passwordErrorCheck) submitLoginAsSeedComp(mobile, password);
      // } else if (!mobileErrorCheck && !passwordErrorCheck){
      //   submitOrgsLogin(mobile, password, 'mobile');
      // }
    }
    this.setState({
      passwordError: passwordErrorCheck,
    });
  };

  _toggleEmailMobile = (ev) => {
    if (ev.key !== 'Tab') {
      const { loginViaEmail } = this.state;
      this.setState({
        loginViaEmail: !loginViaEmail,
        mobile: '',
        email: '',
        password: '',
        mobileError: false,
        passwordError: false,
        emailError: false,
      });
    }
  };

  handleKeyPress = (ev) => {
    if (ev.key === 'Enter') {
      this._submitLogin();
      ev.preventDefault();
    }
  };

  _renderLoginButtons = () => {
    const {
      mobile,
      email,
      password,
      mobileError,
      passwordError,
      emailError,
      loginViaEmail,
      accountType,
      accountTypeName,
      accountValue,
    } = this.state;
    const { language } = this.context;
    const { loginError } = this.props;
    return (
      <div>
        {loginViaEmail ? (
          <TextField
            error={!!emailError}
            helperText={emailError ? 'Please enter valid email id' : ''}
            id="email"
            label="Email ID"
            className="textField inputHead customText-width"
            margin="normal"
            value={email}
            onChange={ev => this._handleLogin('email', ev)}
          />
        ) : (
          <TextField
            error={!!mobileError}
            helperText={mobileError ? 'Please enter valid mobile number' : ''}
            id="mobile"
            label={
              (language.hindi && language.hindi['Mobile No.']) || 'Mobile No.'
            }
            className="textField inputHead customText-width"
            margin="normal"
            value={mobile}
            onChange={ev => this._handleLogin('mobile', ev)}
            onKeyPress={ev => this.handleKeyPress(ev)}
          />
        )}
        <TextField
          error={!!passwordError}
          helperText={
            passwordError ? 'Password should be greater than 8 digit' : ''
          }
          id="password"
          label={
            (language.hindi && language.hindi['enter password']) || 'Password'
          }
          className="textField inputHead customText-width"
          margin="normal"
          type="password"
          value={password}
          onChange={ev => this._handleLogin('password', ev)}
          onKeyPress={ev => this.handleKeyPress(ev)}
        />
        <p className="errorMsg">{loginError}</p>
        {/* <Link to="/" className="forgotPassword">
          Forgot Password?
        </Link> */}
        <div className="darkgreenBtnHeader">
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button darkgreenBtnInfo"
            onClick={this._submitLogin}
          >
            {(language.hindi && language.hindi.Login) || 'Login'}
          </Button>
        </div>
        <ul className="modalButtons">
          {/*
          <li className="button-label">Login by Email ID</li>
*/}
          {/* <li className="darkgreenBtnHeader">
            <Button
              type="submit"
              variant="contained"
              color="primary"
              className="button darkgreenBtn"
              onClick={this._submitLogin}
            >
              {(language.hindi && language.hindi.Login) || 'Login1111'}
            </Button>
          </li> */}
          {/*          <li className="orText">
            {(language.hindi && language.hindi.or) || 'or sign in with'}
          </li> */}
          <SocialLogin
            accountType={accountType}
            accountTypeName={accountTypeName}
            accountValue={accountValue}
          />
        </ul>
        {/* <div className="loginbyEmail">
          <p>Login by Email ID</p>

        </div>
        <div className="signin">
          <p></p>
        </div> */}
      </div>
    );
  };

  moveToPricing = (e) => {
    e.preventDefault();
    const { history } = this.props;
    history.push('/chooseplan');
  };

  render() {
    const { open, accountValue } = this.state;
    const { language } = this.context;
    const { userType, openLoginModal } = this.props;
    return (
      <div>
        <Button
          // role="button"
          onClick={this.handleOpen}
          tabIndex="0"
          className="siFoloBtn"
        >
          {(language.hindi && language.hindi.Login) || 'Login'}
        </Button>
        <Dialog
          maxWidth={false}
          onClose={this._handleClose}
          aria-labelledby="customized-dialog-title"
          open={open || openLoginModal}
        >
          <div className="registerModal modalHead">
            <div className="paper modalCarousel">
              <div
                role="button"
                tabIndex="0"
                className="modalCloseIcon mobileCloseIcon"
                onClick={this._handleClose}
                onKeyDown={this._handleClose}
              >
                <i className="material-icons">close</i>
              </div>
              <Grid container>
                {/*! isRegistered ? (
                  <Box display={{ xs: 'block', sm: 'none' }}>
                    <Grid item>
                      <Carousel />
                    </Grid>
                  </Box>
                ) : null */}
                <Grid item lg={7} md={7} sm={7} xs={12} className="modalSec">
                  <React.Fragment>
                    <h5>Welcome Back</h5>
                    <h4 className="createAccountHeading">
                      {(language.hindi && language.hindi['Login as'])
                        || 'Login as'}
                      <FormControl className="formControl inputHead coloredForms">
                        <Select
                          disableUnderline
                          name="login-organisation-name"
                          className="selectEmpty modalDropdown"
                          inputProps={{ 'aria-label': 'user' }}
                          onChange={this._handleAccountType}
                          value={accountValue}
                          displayEmpty
                        >
                          <MenuItem value="">Select User</MenuItem>
                          {userType.map(item => (
                            <MenuItem
                              value={`${item.organisationTypeID}//${item.organisationTypeName}`}
                              key={item.organisationTypeID}
                            >
                              {item.organisationTypeName}
                              {' '}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </h4>
                    {this._renderLoginButtons()}
                  </React.Fragment>
                </Grid>

                <Grid
                  item
                  lg={5}
                  md={5}
                  sm={5}
                  xs={12}
                  className="modal-back-img"
                >
                  <Box display={{ xs: 'none', sm: 'block' }}>
                    <div className="button-area">
                      <div className="modalHeading">
                        <h4>Benefits for Joining Us!</h4>
                        <div
                          role="button"
                          tabIndex="0"
                          className="modalCloseIcon"
                          onClick={this._handleClose}
                          onKeyDown={this._handleClose}
                        >
                          <i className="material-icons">clear</i>
                        </div>
                      </div>
                      <ul>
                        <li>
                          <a href="/">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Your Farm Rating
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Get Insurance
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Get Insurance
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Expert Visit
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            {' '}
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Farmguide Credit Card
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Expert Visit
                          </a>
                        </li>
                        <li>
                          <a href="/">
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              className="customise-circle"
                            >
                              <circle fill="#95e5b3" cx="12" cy="12" r="8" />
                            </svg>
                            Government Subsidy
                          </a>
                        </li>
                      </ul>
                    </div>
                    <div className="downloadBtn">
                      <Button onClick={this.moveToPricing}>
                        <i />
                        Our subscriptions
                      </Button>
                      <Button>
                        <i />
                        Download farmguide App
                      </Button>
                    </div>
                  </Box>
                </Grid>
              </Grid>
            </div>
          </div>
        </Dialog>

        {/* Successful Registration Modal */}
      </div>
    );
  }
}

// class LoginModal extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       open: false,
//       mobile: '',
//       email: '',
//       password: '',
//       mobileError: false,
//       passwordError: false,
//       emailError: false,
//       loginViaEmail: false,
//     };
//   }

//   componentDidUpdate(prevProps) {
//     const {
//       cookies, userData, history, isLogin,
//     } = this.props;
//     if (isLogin !== prevProps.isLogin) {
//       cookies.set('userData', userData, { path: '/' });
//       history.push({
//         pathname: '/myaccount',
//         search: '',
//         hash: '',
//         state: { from: 'login' },
//       });
//       // history.push('/myaccount');
//     }
//   }

//   _handleClose = () => {
//     const { resetRegistration } = this.props;
//     this.setState({
//       open: false,
//       mobile: '',
//       email: '',
//       password: '',
//       mobileError: false,
//       passwordError: false,
//       emailError: false,
//       loginViaEmail: false,
//     });
//     resetRegistration();
//   };

//   handleOpen = (ev) => {
//     if (ev.key !== 'Tab') {
//       this.setState({
//         open: true,
//       });
//     }
//   };

//   _handleLogin = (type, ev) => {
//     if (type === 'mobile') {
//       if (ev.target.value.length <= 10) {
//         this.setState({
//           mobile: ev.target.value,
//           mobileError: false,
//         });
//       }
//     } else if (type === 'password') {
//       this.setState({
//         password: ev.target.value,
//         passwordError: false,
//       });
//     } else if (type === 'email') {
//       this.setState({
//         email: ev.target.value,
//         emailError: false,
//       });
//     }
//   };

//   _submitLogin = () => {
//     const { submitLogin } = this.props;
//     const {
//       mobile, password, email, loginViaEmail,
//     } = this.state;
//     const passwordErrorCheck = !isPassword(password);
//     if (loginViaEmail) {
//       const emailErrorCheck = !isEmail(email);
//       this.setState({
//         emailError: emailErrorCheck,
//       });
//       if (!emailErrorCheck && !passwordErrorCheck) submitLogin(email, password, 'email');
//     } else {
//       const mobileErrorCheck = !isMobile(mobile);
//       this.setState({
//         mobileError: mobileErrorCheck,
//       });
//       if (!mobileErrorCheck && !passwordErrorCheck) submitLogin(mobile, password, 'mobile');
//     }
//     this.setState({
//       passwordError: passwordErrorCheck,
//     });
//   };

//   _toggleEmailMobile = (ev) => {
//     if (ev.key !== 'Tab') {
//       const { loginViaEmail } = this.state;
//       this.setState({
//         loginViaEmail: !loginViaEmail,
//         mobile: '',
//         email: '',
//         password: '',
//         mobileError: false,
//         passwordError: false,
//         emailError: false,
//       });
//     }
//   };

//   render() {
//     //  console.log('fhjfh')
//     const {
//       open,
//       mobile,
//       email,
//       password,
//       mobileError,
//       passwordError,
//       emailError,
//       loginViaEmail,
//     } = this.state;
//     const { loginError } = this.props;
//     const { language } = this.context;
//     return (
//       <div>
//         <Button
//           // role="button"
//           className="siFoloBtn"
//           onClick={this.handleOpen}
//           onKeyDown={this.handleOpen}
//           tabIndex="0"
//         >
//           {(language.hindi && language.hindi.Login) || 'Login'}
//         </Button>
//         {/* <Modal
//           open={open}
//           onClose={this._handleClose}
//           showCloseIcon={false}
//           closeOnOverlayClick={false}
//           center
//         > */}
//         <Dialog
//           maxWidth={false}
//           onClose={this._handleClose}
//           aria-labelledby="customized-dialog-title"
//           open={open}
//         >
//           <div className="loginModal modalHead">
//             <div className="paper modalCarousel">
//               <div className="modalSec">
//                 <div className="modalContent">
//                   <Typography variant="h5">
//                     {loginViaEmail
//                       ? (language.hindi
//                           && language.hindi['login by email ID'])
//                         || 'Enter your Email Id to'
//                       : (language.hindi
//                           && language.hindi['enter your mobile no'])
//                         || 'Enter your mobile no. to'}
//                     <strong>
//                       {(language.hindi && language.hindi.Login) || 'Login'}
//                     </strong>
//                   </Typography>
//                   {loginViaEmail ? (
//                     <TextField
//                       error={!!emailError}
//                       helperText={
//                         emailError ? 'Please enter valid email id' : ''
//                       }
//                       id="email"
//                       label="Email ID"
//                       className="textField inputHead"
//                       margin="normal"
//                       value={email}
//                       onChange={ev => this._handleLogin('email', ev)}
//                     />
//                   ) : (
//                     <TextField
//                       error={!!mobileError}
//                       helperText={
//                         mobileError ? 'Please enter valid mobile number' : ''
//                       }
//                       id="mobile"
//                       label={
//                         (language.hindi && language.hindi['Mobile No.'])
//                         || 'Mobile No.'
//                       }
//                       className="textField inputHead"
//                       margin="normal"
//                       value={mobile}
//                       onChange={ev => this._handleLogin('mobile', ev)}
//                     />
//                   )}
//                   <TextField
//                     error={!!passwordError}
//                     helperText={
//                       passwordError
//                         ? 'Password should be greater than 8 digit'
//                         : ''
//                     }
//                     id="password"
//                     label={
//                       (language.hindi && language.hindi['enter password'])
//                       || 'Password'
//                     }
//                     className="textField inputHead"
//                     margin="normal"
//                     type="password"
//                     value={password}
//                     onChange={ev => this._handleLogin('password', ev)}
//                   />
//                   <p className="errorMsg">{loginError}</p>
//                   {/* <a href="/" className="forgotPasswordLink">
//                     Forgot password
//                   </a> */}
//                   <ul>
//                     <li className="greyBtnHeader">
//                       <Button
//                         variant="contained"
//                         className="button greyBtn"
//                         onClick={() => this._handleClose(false)}
//                       >
//                         {(language.hindi && language.hindi.Close) || 'Close'}
//                       </Button>
//                     </li>
//                     <li className="darkgreenBtnHeader">
//                       <Button
//                         variant="contained"
//                         color="primary"
//                         className="button darkgreenBtn"
//                         onClick={this._submitLogin}
//                       >
//                         {(language.hindi && language.hindi.ok) || 'Done'}
//                       </Button>
//                     </li>
//                   </ul>
//                   <p className="centerAlign">
//                     <span
//                       className="emailLoginLink"
//                       onClick={ev => this._toggleEmailMobile(ev)}
//                       tabIndex="0"
//                       role="button"
//                       onKeyDown={ev => this._toggleEmailMobile(ev)}
//                     >
//                       {(language.hindi && language.hindi['Login By'])
//                         || 'Login By'}
//                       {' '}
//                       {!loginViaEmail
//                         ? (language.hindi
//                             && language.hindi['login by email ID'])
//                           || 'Email ID'
//                         : (language.hindi
//                             && language.hindi['login by mobile no'])
//                           || 'Mobile'}
//                       {' '}
//                       ?
//                     </span>
//                   </p>
//                   <Grid item sm={8} xs={12} className="modal-back-img">
//                     <Box display={{ xs: 'none', sm: 'block' }}>
//                       <div className="button-area">
//                         <div className="modalHeading">
//                           <h4>Benefits for Joining Us!</h4>
//                           <div
//                             role="button"
//                             tabIndex="0"
//                             className="modalCloseIcon"
//                             onClick={this.handleClose}
//                             onKeyDown={this.handleClose}
//                           >
//                             <i className="material-icons">clear</i>
//                           </div>
//                         </div>
//                         <ul>
//                           <li>
//                             <a href="/">
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Your Farm Rating
//                             </a>
//                           </li>
//                           <li>
//                             <a href="/">
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Get Insurance
//                             </a>
//                           </li>
//                           <li>
//                             <a href="/">
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Get Insurance
//                             </a>
//                           </li>
//                           <li>
//                             <a href="/">
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Expert Visit
//                             </a>
//                           </li>
//                           <li>
//                             <a href="/">
//                               {' '}
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Farmguide Credit Card
//                             </a>
//                           </li>
//                           <li>
//                             <a href="/">
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Expert Visit
//                             </a>
//                           </li>
//                           <li>
//                             <a href="/">
//                               <svg
//                                 width="24"
//                                 height="24"
//                                 viewBox="0 0 24 24"
//                                 className="customise-circle"
//                               >
//                                 <circle fill="#95e5b3" cx="12" cy="12" r="8" />
//                               </svg>
//                               Government Subsidy
//                             </a>
//                           </li>
//                         </ul>
//                       </div>
//                       <div className="downloadBtn">
//                         <Button>
//                           <i />
//                           Download farmguide App
//                         </Button>
//                       </div>
//                     </Box>
//                   </Grid>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </Dialog>
//       </div>
//     );
//   }
// }

LoginModal.contextType = LanguageContext;

export default withRouter(
  connect(
    ({ app }) => ({
      userData: app.userData,
      isLogin: app.isLogin,
      loginError: app.loginError,
      userType: app.userType,
      openLoginModal: app.openLoginModal,
    }),
    dispatch => ({
      submitLogin: (method, password, type) => dispatch(submitLoginAction(method, password, type)),
      resetRegistration: () => dispatch(resetRegistrationAction()),
      submitOrgsLogin: (m, p, t) => dispatch(submitOrgsLoginAction(m, p, t)),
      submitFarmconnectLogin: (m, p, t) => dispatch(submitFarmconnectLoginAction(m, p, t)),
      submitLoginAsSeedComp: (m, p) => dispatch(submitLoginAsSeedCompAction(m, p)),
      handleLoginModal: bool => dispatch(handleLoginModalAction(bool)),
    }),
  )(withCookies(LoginModal)),
);

/* <ul className="modalButtons">
          <li className="darkgreenBtnHeader">
            <Button
              variant="contained"
              className="button darkgreenBtn"
              onClick={() => {
                console.log('clikcked1');
              }}
            >
              {(language.hindi && language.hindi.Mobile) || 'Mobile'}
            </Button>
          </li>
          <li className="orText">
            {(language.hindi && language.hindi.or) || 'or'}
          </li>
        </ul> */

/* <TextField
          id=""
          label={
            (language.hindi && language.hindi['Mobile Number']) || 'Mobile Number'
          }
          className="textField inputHead customText-width"
          margin="normal"
          value=""
          onChange={event => this._handleLogin('mobileNumber', event)}
          error={!!mobileError}
          helperText={mobileError ? 'Please enter valid mobile number' : ''}
        />
        <TextField
          id=""
          label={
            (language.hindi && language.hindi['Password']) || 'Password'
          }
          className="textField inputHead customText-width"
          margin="normal"
          value=""
          onChange={event => this._handleLogin('mobileNumber', event)}
          error={!!mobileError}
          helperText={mobileError ? 'Please enter valid mobile number' : ''}
        />
          <Link to="/" className="forgotPassword">
             Forgot Password
          </Link>
          <div className="loginbyEmail">
            <p>Login by Email ID</p>
            <li className="darkgreenBtnHeader">
              <Button
                variant="contained"
                color="primary"
                className="button darkgreenBtn"
                onClick={this.__submitLogin}
              >
                {(language.hindi && language.hindi['Login'])
                  || 'Login'}
              </Button>
            </li>
          </div>
          <div className="signin">
            <p>or sign in with</p>
          </div>
        <SocialLogin/>
      </div> */
